import type { Optional } from '@festina-life/core'
import cx from 'classnames'
import type { ComponentProps, MouseEvent, PropsWithChildren } from 'react'
// oxlint-disable-next-line no-restricted-imports -- kept to not break too many things in the config portal
import { Link } from 'react-router'

import type { ConfigurationItem } from '../../types/common'
import { isParameterValueItem } from '../../uiModels/parameterOperations/parameterConfigurationItems'
import { ConfigurationItemIcon } from '../configurationItemIcon/ConfigurationItemIcon'
import { ValueEntityIndicator } from '../valueEntityIndicator/ValueEntityIndicator'
import { operationLinkClassName } from './helpers'

type Props = PropsWithChildren<{
  to?: Optional<string>
  type: ConfigurationItem
  /** Overrides the icon shown. Defaults to `type`. */
  iconType?: ConfigurationItem
  onClick?: (event: MouseEvent<HTMLAnchorElement> | undefined) => void
  label: string
  isDraft: boolean
  isAnnulledValue?: boolean
}>

export const OperationLink = ({
  to,
  type,
  iconType,
  onClick,
  label,
  children,
  isDraft,
  isAnnulledValue,
}: Props) => {
  const LinkElement = to ? Link : 'span'
  const componentProps = {
    onClick,
    className: operationLinkClassName({ isInteractive: !!to, isDraft }),
    ...(to ? { to } : {}),
  } as ComponentProps<typeof Link>

  const isAnnulOperation = type === 'annulOperation'

  const itemKind = iconType ?? type
  const isAmendment = itemKind === 'parameterValueAmendment'
  const isParameterValueRow =
    isParameterValueItem(itemKind) || !!isAnnulledValue

  return (
    <LinkElement {...componentProps}>
      <div className="flex items-center overflow-hidden gap-x-2">
        <ConfigurationItemIcon type={itemKind} />
        <span
          className={cx('truncate', {
            'line-through': isAnnulOperation,
          })}
        >
          {label}
        </span>
        {isParameterValueRow && (
          <ValueEntityIndicator isAmendment={isAmendment} />
        )}
      </div>
      <div className="flex items-center flex-wrap gap-x-1">{children}</div>
    </LinkElement>
  )
}
